import '../PageFillTheForm/page-FillTheForm.css';

import Title from '../../@common.blocks/Title';
import ElectroTest from '../../pictures/electrician-test.jpeg';
import emailjs from '@emailjs/browser';
import React, { useRef } from 'react';

import ToggleContent from '../../@common.blocks/Modal/ToggleContent';

const PageFillTheForm = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm('service_lzgr3rn', 'template_zlwou7k', form.current, {
        publicKey: 'HB8vTok4NtjOnmvbG',
      })
      .then(
        () => {
          console.log('SUCCESS!');
        },
        (error) => {
          console.log('FAILED...', error.text);
        }
      );
  };
  return (
    <div>
      <div className="page-FillTheForm">
        <div className="page-FillTheForm__img">
          <img src={ElectroTest} alt="" />
        </div>
        <div className="page-FillTheForm__messange">
          <Title level="2" component="message">
            Отправьте нам сообщение
          </Title>
          <div className="page-FillTheForm__feedback">
            <form ref={form} onSubmit={sendEmail}>
              <div className="page-FillTheForm__input">
                <input
                  type="text"
                  className="page-FillTheForm__field"
                  name="name"
                  placeholder="Укажите ваше имя:"
                  required
                  id="name"
                />
              </div>
              <div className="page-FillTheForm__input">
                <input
                  type="email"
                  className="page-FillTheForm__field"
                  name="email"
                  placeholder="Укажите ваш электронный адрес:"
                  required
                  id="email"
                />
              </div>
              <div className="page-FillTheForm__input">
                <input
                  type="text"
                  className="page-FillTheForm__field"
                  name="phone"
                  placeholder="Укажите ваш телефон:"
                  required
                  id="phone"
                />
              </div>
              <div class="page-FillTheForm__message-box">
                <textarea
                  name="message"
                  rows="4"
                  cols="50"
                  placeholder="Введите ваше сообщение:"
                  id="message"
                ></textarea>
              </div>
              <ToggleContent />
              <div className="section-connection__status"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PageFillTheForm;
